<template>
  <div class="popModalBox">
    <div class="popModalContent" :style="{ width: widthBox }">
      <div class="popModalHeader">
        <div class="title">
          {{ title }}
        </div>
        <div class="close" @click="closePop()">
          <img src="@/assets/images/close.png" alt="">
        </div>
      </div>
      <div class="subTitle" v-if="subTitle">{{ subTitle }}</div>
      <slot name="mainContent"></slot>
      <div class="btn" v-if="Cancel || Submit">
        <span v-if="Cancel" class="Cancel" @click="cancel()">{{ Cancel }}</span>
        <span v-if="Submit" class="Submit" @click="save()">{{ Submit }}</span>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import { ShowWarningMessage, ShowSuccessMessage } from '@/components/modal/tips/message-tips';
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    Cancel: {
      type: String,
      default: '',
    },
    Submit: {
      type: String,
      default: '',
    },
    modalWidth: {
      type: Number,
      default: 500,
    },
  },
  components: {
  },
  data() {
    return {
      dataLoading: false,
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
    widthBox() {
      return `${this.modalWidth}px`;
    },
  },
  mounted() {
  },
  methods: {
    closePop() {
      this.$emit('closePop');
    },
    cancel() {
      this.$emit('cancel');
    },
    save() {
      this.$emit('save');
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/styles/element-variables.scss';

.popModalBox {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(102, 112, 133, 0.7);
  top: 0;
  left: 0;

  .popModalContent {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-color: white;
    padding: 24px;
    box-sizing: border-box;
    border-radius: 18px 18px 18px 18px;
    border: 1px solid #EFEFF4;

    .popModalHeader {
      display: flex;
      justify-content: space-between;

      .title {
        font-weight: bold;
        font-size: 20px;
        color: #667085;
        align-items: center;
        line-height: 30px;
      }

      .close {
        width: 18px;
        height: 18px;

        img {
          width: 18px;
          height: 18px;
          cursor: pointer;
        }
      }
    }

    .subTitle {
      margin-top: 8px;
      font-weight: 400;
      font-size: 12px;
      color: #667085;
      line-height: 18px;
    }

    .btn {
      text-align: right;
      margin-top: 24px;

      span {
        display: inline-block;
        text-align: center;
        cursor: pointer;
      }

      .Cancel {
        width: 98px;
        height: 38px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #503DF6;
        font-size: 16px;
        color: #503DF6;
        line-height: 38px;
        margin-right: 16px;
      }

      .Submit {
        width: 83px;
        height: 38px;
        background: #503DF6;
        border-radius: 8px 8px 8px 8px;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 38px;
      }
    }
  }
}
</style>
